<template>

    <div class="carousel-wrapper" v-bind:style="height">

        <div class="info-overlay"  v-show="!expanded">
            <p class="line">{{tasks}}</p>
        </div>

        <div :id="'slider' + project.id" class="carousel slide w-100" data-ride="carousel" data-interval="false">


            <template v-if="project.images">
            <!--Indikatoren-->
            <transition name="fade-down">
                    <ol class="carousel-indicators" v-show="expanded && sliderLoaded">
                        <li v-for="(image, index) in project.images.image" v-bind:key="index" v-bind:data-target="'#slider' + project.id" v-bind:data-slide-to="index" v-bind:class="{active: index === 0}"></li>
                    </ol>
            </transition>
            <!--/.Indikatoren-->
            </template>

            <!--Slides-->
            <div class="carousel-inner" v-on:click="$emit('slider-click')" ref="carouselInner" v-bind:class="{'closed': !expanded}">
                <template v-if="project.images">
                     <div class="carousel-item" v-for="(image, index) in images" v-bind:key="index" v-bind:class="{active: index === 0}" >
                            <img class="d-block w-100" :src="imglqRootPath + image.url" :data-src="imgRootPath + image.url" :alt="'Projektbild ' + project.name">
                        </div>
                </template>
            </div>
            <transition name="fade-left">
                <a class="carousel-control-prev" :href="'#slider' +  project.id" role="button"
                   data-slide="prev" v-show="expanded && sliderLoaded">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
            </transition>
            <transition name="fade-right">
                <a class="carousel-control-next" :href="'#slider' +  project.id"  role="button"
                   data-slide="next" v-show="expanded && sliderLoaded">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </transition>
        </div>
        <!--/.Slides-->
    </div>
</template>


<script>
    //yimport $ from 'jquery';

    export default {
        name: "TileSlider",
        props: {
            project: {},
            aspectratio: {
                default: 3.2,
                type: Number
            },
            expanded: {
                default: false,
                type: Boolean
            }
        },
        data: function () {
            return {
                height: {
                },
                observer: new IntersectionObserver(this.handleIntersection, {
                    rootMargin: '0px',
                    threshold: 0.1
                }),
                sliderLoaded: false,
                sliderOpended: false,
                imgRootPath: "https://www.robinjuenkersfeld.de/img/projects/",
                imglqRootPath: "https://www.robinjuenkersfeld.de/img/projects_lq/"
            };

        },

        computed: {
            tasks: function () {

                let tasks = '';

                if (this.project.tasks) {
                    tasks = this.project.tasks.join(' & ');
                }

                return tasks;
            },

            wrapperHeight: function () {
                let cropHeight = 100 / this.aspectratio / 2;
                return {
                    paddingTop: cropHeight + '%',
                    paddingBottom: cropHeight + '%',
                };

            },
            imageHeight: function () {
                let halfHeight = (this.$refs.carouselInner.getElementsByClassName('active')[0].offsetHeight / 2);
                return {
                    paddingTop: halfHeight + 'px',
                    paddingBottom: halfHeight + 'px',
                };
            },
            images: function () {
                if(!this.sliderOpended){
                    return [this.project.images.image[0]];
                }
                    return this.project.images.image;
            }

        },

        watch:  {
            expanded: function () {
                if (!this.expanded) {
                    this.height = this.wrapperHeight;
                } else {
                    this.height = this.imageHeight;
                    this.sliderOpended = true;
                }


            }
        },

        methods: {

            handleIntersection: function(entries){
                const $this = this;
                entries.forEach(entry => {
                    if(entry.intersectionRatio > 0) {
                        this.observer.disconnect();
                        let images = entry.target.getElementsByTagName('img');
                        $this.loadImage(images[0])
                    }
                })
            },

            loadSliderImages: function() {
                const $this = this;
                const sliderImages = [...this.$refs.carouselInner.getElementsByTagName('img')];

                sliderImages.forEach(function (img) {
                    $this.loadImage(img)
                });
                this.sliderLoaded = true;
            },

            loadImage: function(image) {
                const src = image.dataset.src;
                this.fetchImage(src).then(() => {
                    image.src = src;
                })
            },

            fetchImage: function(url) {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                        image.src = url;
                    image.onload = resolve;
                    image.onerror = reject;
                });
            },
        },
        mounted() {
            // Register an event listener when the Vue component is ready
            this.height = this.wrapperHeight;
            this.observer.observe(this.$refs.carouselInner);
        },
        updated(){
            if(!this.sliderLoaded && this.expanded) {
                this.loadSliderImages()
                console.log("sliderLoaded");
            }
        }
    };
</script>

